import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/data';

const coverImages: Record<string, string> = {
  'comic-cover-01': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20cover%20art%2C%20beautiful%20romance%20couple%20illustration%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20vibrant%20warm%20colors%2C%20artistic%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
  'comic-cover-02': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20sword%20warrior%20in%20magical%20world%2C%20dramatic%20lighting%2C%20clean%20background%2C%20modern%20digital%20illustration%2C%20professional%20comic%20style%2C%20vibrant%20warm%20tones&width=600&height=800&seq=comic-cover-02&orientation=portrait',
  'comic-cover-03': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20martial%20arts%20fighter%20dynamic%20pose%2C%20intense%20dramatic%20lighting%2C%20clean%20minimal%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20vibrant%20colors&width=600&height=800&seq=comic-cover-03&orientation=portrait',
  'comic-cover-04': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20funny%20office%20workers%20illustration%2C%20bright%20cheerful%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20style%2C%20warm%20playful%20colors&width=600&height=800&seq=comic-cover-04&orientation=portrait',
  'comic-cover-05': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%2C%20mysterious%20dark%20atmosphere%2C%20suspenseful%20illustration%2C%20dim%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20moody%20tones&width=600&height=800&seq=comic-cover-05&orientation=portrait',
  'comic-cover-06': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20emotional%20character%20portrait%20in%20cozy%20cafe%2C%20warm%20nostalgic%20lighting%2C%20clean%20background%2C%20modern%20digital%20illustration%2C%20professional%20comic%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
  'comic-cover-07': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%2C%20group%20of%20teenage%20friends%20illustration%2C%20bright%20sunny%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20fresh%20youthful%20colors&width=600&height=800&seq=comic-cover-07&orientation=portrait',
  'comic-cover-08': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20cover%2C%20elegant%20two%20male%20characters%20in%20moonlight%2C%20soft%20romantic%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20style%2C%20beautiful%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
};

export default function FeaturedSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门韩漫推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选高分韩漫作品，韩漫下载安装后即可离线畅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredComics.slice(0, 8).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer border border-background-200/70"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={coverImages[comic.coverSeq]}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium rounded-full whitespace-nowrap">
                    <i className="ri-star-fill text-yellow-400 text-xs w-3 h-3 flex items-center justify-center"></i>
                    {comic.rating}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span
                    className={`inline-block px-2.5 py-1 text-xs font-medium rounded-full whitespace-nowrap ${
                      comic.status === '已完结'
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-primary-500 text-background-50'
                    }`}
                  >
                    {comic.status}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-1 whitespace-nowrap">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                  {comic.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-book-read-line w-3 h-3 flex items-center justify-center"></i>
                    {comic.chapters}话
                  </span>
                  <span>{comic.categoryName}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多韩漫
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}